import React, { useRef, useState } from 'react';
import { SectionTitle, SubsectionWrapper } from 'screens/DeveloperPage/styled';
import { useLocale } from 'locale';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import * as Styled from './styled';


export const PromotionVideo: React.FC<{ videoUrl: string; }> = ({ videoUrl }) => {
  const { t } = useLocale();
  const el = useRef<HTMLDivElement>(null);
  const [ visible, setVisible ] = useState(false);
  const [ loaded, setLoaded ] = useState(false);

  useIntersectionObserver(([ e ]) => {
    if (e.isIntersecting) {
      setVisible(true);
    }
  }, [ el ], { threshold: 0 });


  return (
    <SubsectionWrapper>
      <SectionTitle>{t('developerPage.promotionVideo.title')}</SectionTitle>
      <Styled.VideoWrapper>
        <Styled.VideoInner ref={el}>
          {visible ? (
            <iframe
              data-auto="developer-video"
              onLoad={() => setLoaded(true)}
              src={videoUrl}
              title={t('developerPage.promotionVideo.videoTitle')}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : null}
          {loaded ? null : (
            <Styled.VideoPlaceholder>
              <Styled.VideoPlaceholderBg />
            </Styled.VideoPlaceholder>
          )}
        </Styled.VideoInner>
      </Styled.VideoWrapper>
    </SubsectionWrapper>
  );
};
